// extracted by mini-css-extract-plugin
export var modal = "_j1-0";